import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Wrapper,
  FloatingLabel,
  ContentWrapper,
  Underline,
  TimeInput as Input,
} from '@layout/CustomFormFields';

class TimeInput extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    floatingLabelText: PropTypes.node.isRequired,
    onChange: PropTypes.func.isRequired,
    hours: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    minutes: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  };

  static intToTime = (int) => String(int).padStart(2, '0');

  static increaseHours = ({ hours }) => ({
    hours: TimeInput.intToTime((+hours + 1) % 24),
  });

  static decreaseHours = ({ hours }) => ({
    hours: TimeInput.intToTime((24 + +hours - 1) % 24),
  });

  static increaseMinutes = ({ minutes }) => {
    const nextMinutes = (+minutes + 15) % 60;
    const roundedMinutes = Math.floor(nextMinutes / 15) * 15;
    return {
      minutes: TimeInput.intToTime(roundedMinutes),
    };
  };

  static decreaseMinutes = ({ minutes }) => {
    const nextMinutes = (60 + +minutes - 15) % 60;
    const roundedMinutes = (Math.ceil(nextMinutes / 15) * 15) % 60;
    return {
      minutes: TimeInput.intToTime(roundedMinutes),
    };
  };

  state = {
    hours: this.hours,
    minutes: this.minutes,
    focused: false,
  };

  get safeProps() {
    const { id, onChange, ...rest } = this.props;
    return rest;
  }

  get hours() {
    return TimeInput.intToTime(this.props.hours);
  }

  get minutes() {
    return TimeInput.intToTime(this.props.minutes);
  }

  get cases() {
    return {
      ArrowRightHours: () => {
        this.setFocus('minutes');
      },
      ArrowLeftMinutes: () => {
        this.setFocus('hours');
      },
      ArrowUpHours: () => {
        this.setState(TimeInput.increaseHours);
      },
      ArrowDownHours: () => {
        this.setState(TimeInput.decreaseHours);
      },
      ArrowUpMinutes: () => {
        this.setState(TimeInput.increaseMinutes);
      },
      ArrowDownMinutes: () => {
        this.setState(TimeInput.decreaseMinutes);
      },
    };
  }

  setFocus = (target) => {
    setTimeout(() => {
      document.getElementById(`${this.props.id}-${target}`).focus();
    });
  };

  changeHours = ({ target: { value: hours } }) => {
    if (+hours >= 24 || hours.length > 2 || isNaN(hours)) {
      return false;
    }
    this.setState({ hours });
    if (hours.length >= 2 || +hours > 2) {
      this.setFocus('minutes');
    }
  };

  changeMinutes = ({ target: { value: minutes } }) => {
    if (+minutes >= 60 || minutes.length > 2 || isNaN(minutes)) {
      return false;
    }
    this.setState({ minutes });
  };

  handleKey = (e) => {
    const {
      target: { id },
      key,
    } = e;
    if (!['ArrowUp', 'ArrowRight', 'ArrowDown', 'ArrowLeft'].includes(key)) {
      return false;
    }
    e.preventDefault();
    const targetHours = id === `${this.props.id}-hours`;
    const instruction = `${key}${targetHours ? 'Hours' : 'Minutes'}`;
    this.cases[instruction]();
  };

  onFocus = (e) => {
    this.setState(() => ({
      hours: this.hours,
      minutes: this.minutes,
      focused: true,
    }));
    this.selectText(e);
  };

  onBlur = () => {
    this.setState(
      ({ hours, minutes }) => {
        return {
          hours: TimeInput.intToTime(hours),
          minutes: TimeInput.intToTime(minutes),
          focused: false,
        };
      },
      () => {
        this.props.onChange(this.state.hours, this.state.minutes);
      },
    );
  };

  selectText = ({ target }) => {
    target.select();
  };

  render() {
    const { id, floatingLabelText } = this.props;
    const { hours, minutes, focused } = this.state;
    return (
      <Wrapper id={id} {...this.safeProps}>
        <FloatingLabel
          htmlFor={`${id}-hours`}
          shouldShrink={hours || minutes || focused}
          focused={focused}
        >
          {floatingLabelText}
        </FloatingLabel>
        <ContentWrapper {...this.safeProps}>
          <Input
            id={`${id}-hours`}
            value={focused ? hours : this.hours}
            active={focused}
            onChange={this.changeHours}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onClick={this.selectText}
            onKeyDown={this.handleKey}
          />
          <label htmlFor={`${id}-minutes`}>:</label>
          <Input
            id={`${id}-minutes`}
            value={focused ? minutes : this.minutes}
            active={focused}
            onChange={this.changeMinutes}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onClick={this.selectText}
            onKeyDown={this.handleKey}
          />
        </ContentWrapper>
        <div>
          <Underline {...this.safeProps} />
        </div>
      </Wrapper>
    );
  }
}

export default TimeInput;



// WEBPACK FOOTER //
// ./components/atoms/TimeInput.js